import React from 'react';
import { filterRelatedStreams } from '../helpers';
import CollectionsBlock from './CollectionsBlock';
import GroupsBlock from './GroupsBlock';
import Gallery from './Gallery';
import MoreJournals from './MoreJournals';
import MoreLiterature from './MoreLiterature';
import MorePolls from './MorePolls';
import LatestStatus from './LatestStatus';
import Recommended from './Recommended';
import RecommendedLiterature from './RecommendedLiterature';
import TiersBlock from './TiersBlock';
import { TierStreamType } from './TiersBlock/types';
export var SidebarSection = function (_a) {
    var type = _a.type, deviation = _a.deviation, isLoading = _a.isLoading;
    var streams = filterRelatedStreams(deviation);
    // this ensures that we can safely assume prop present later
    if (!streams[type] && !isLoading && type !== 'selectedTier') {
        return null;
    }
    switch (type) {
        case 'gallery':
            return (React.createElement(Gallery, { parentDeviation: deviation, gallery: streams.gallery, isLoading: isLoading }));
        case 'moreJournals':
            return (React.createElement(MoreJournals, { parentDeviation: deviation, moreJournals: streams.moreJournals, isLoading: isLoading }));
        case 'moreLiterature':
            return (React.createElement(MoreLiterature, { parentDeviation: deviation, moreLiterature: streams.moreLiterature, isLoading: isLoading }));
        case 'morePolls':
            return (React.createElement(MorePolls, { parentDeviation: deviation, morePolls: streams.morePolls, isLoading: isLoading }));
        case 'latestStatus':
            return (React.createElement(LatestStatus, { parentDeviation: deviation, latestStatus: streams.latestStatus, isLoading: isLoading }));
        case 'recommended':
            return (React.createElement(Recommended, { parentDeviation: deviation, recommended: streams.recommended, isLoading: isLoading }));
        case 'recommendedLiterature':
            return (React.createElement(RecommendedLiterature, { parentDeviation: deviation, recommendedLiterature: streams.recommendedLiterature, isLoading: isLoading }));
        case 'collections':
            return (React.createElement(CollectionsBlock, { parentDeviation: deviation, collections: streams.collections, isLoading: isLoading }));
        case 'groups':
            return (React.createElement(GroupsBlock, { deviation: deviation, groups: streams.groups, isLoading: isLoading }));
        case 'selectedTier':
            return (React.createElement(TiersBlock, { streamKey: TierStreamType.SelectedTier, deviation: deviation, isLoading: false }));
        case 'inTiers':
            return (React.createElement(TiersBlock, { streamKey: TierStreamType.InTiers, deviation: deviation, tiers: streams.inTiers, isLoading: isLoading }));
        case 'moreTiers':
            return (React.createElement(TiersBlock, { streamKey: TierStreamType.MoreTiers, deviation: deviation, tiers: streams.moreTiers, isLoading: isLoading }));
        default:
            return null;
    }
};
SidebarSection.displayName = 'SidebarSection';
export default SidebarSection;
//# sourceMappingURL=SidebarSection.js.map